export type AdType =
  | 'sd_banner'
  | 'floor_ad'
  | 'floor_ad_closed'
  | 'floor_ad_closed_copy'
  | 'floor_ad_banner'
  | 'floor_ad_banner_scroll'
  | 'sticky_banner'
  | 'sd_banner_catalog_apps'
  | 'sd_banner_side'
  | 'banner_in_featuring'
  | 'search_sticker' //Переделать когда появится
  | 'categories_partner_banner' //Переделать когда появится
  | 'inread_blog'
  | 'instruction_step';

export type PlatformType = 'desktop' | 'touch';

type OnRenderData = {
  floorAdSize?: {
    width: number;
    height: number;
  };
  stickyAdNode?: HTMLElement;
};

export type CommonRenderRequestParts = {
  onClose?: () => void;
  onError?: (data: unknown) => void;
  onRender?: (data: OnRenderData) => void;
};

export type FloorAdRenderRequest = {
  blockId: string;
  type: 'floorAd';
  platform: PlatformType;
} & CommonRenderRequestParts;

export type BannerRenderRequest = {
  blockId: string;
  renderTo: string;
} & CommonRenderRequestParts;

export type AdvManager = {
  render: (
    props: FloorAdRenderRequest | BannerRenderRequest,
    renderFallback: (() => void) | undefined,
  ) => void;
  getPlatform: () => PlatformType;
};

export type FloorAdProps = {
  mode: 'floor_ad' | 'floor_ad_closed' | 'floor_ad_closed_copy';
  env: {
    YANDEX_ADS_FLOOR_AD_DESKTOP_ID: string;
    YANDEX_ADS_FLOOR_AD_MOBILE_ID: string;
    YANDEX_ADS_FLOOR_AD_ALT_DESKTOP_ID: string;
    YANDEX_ADS_FLOOR_AD_ALT_MOBILE_ID: string;
  };
  adFoxConfig: AdFoxConfig;
};

export type BannerPlacementType =
  | 'floor_ad_banner' // баннер на месте обычного floor_ad (показывается сразу)
  | 'floor_ad_banner_scroll' // см выше, но + показывается после скролла страницы (отдельно тк отдельный адфокс)
  | 'apps_list' // баннеры в списке приложений
  | `interesting_apps_${number}` // баннера на новой главной приложений
  | `interesting_games_${number}` // баннера на новой главной игр
  | 'app_card' // старая карточка приложения над отзывами
  | 'new_app_card' // новая карточка приложения - над рекомендациями (везде) + низ правой колонки (десктоп)
  | 'left_sidebar' // баннер под категорими на старой главной
  | 'right_sidebar' // баннер справа на пустоте
  | 'search' //стикер в поиске
  | `categories_${'mob' | 'desktop'}` //Баннер под категориями на странице интересное
  | 'inread_blog'
  | `instruction_step`; // Баннер под шагом инструкции

export type BannerProps = {
  blockId: string;
  placement: BannerPlacementType;
  bannerContainerClassName: string;
  adType: AdType;
  position?: number;
  onRender?: () => void;
  onError?: () => void;
  onNoAds?: () => void;
  adFoxConfig: AdFoxConfig;
};

export type AdCallbacksExtended = AdFox.AdCallbacks & {onClick?: VoidFunction};

export type EmbedCodeBase = Omit<AdFox.EmbedCode, 'containerId'>;

export type AdCallbacksExtendedFactory = (props: {
  containerId: string;
  code: EmbedCodeBase;
  cleanupCallbacks: VoidFunction[];
}) => AdCallbacksExtended;

export type AdFoxStatsEvent = {
  eventName: string;
  payload: Record<string, string>;
};

export type AdFoxScriptState = 'not_initialized' | 'loaded' | 'failed';
export const AD_REFRESH_TRIGGERS = [
  'timer',
  'window_focus',
  'navigation',
] as const;
export type AdRefreshTrigger = (typeof AD_REFRESH_TRIGGERS)[number];

export enum AdResponseType {
  HAS_ADS = '1',
  NO_ADS = '2',
}

export type Logs = {
  requested: (slotId: string, position?: number) => void;
  gotResponse: (
    slotId: string,
    position: number,
    extraParams: {AdResponse: AdResponseType},
  ) => void;
  blocked: (slotId: string, position?: number) => void;
  rendered: (slotId: string, position?: number) => void;
  shown: (slotId: string, position?: number) => void;
  clickedOptions: (slotId: string, position?: number) => void;
  closed: (slotId: string, position?: number) => void;
  nothingToShow: (slotId: string, position?: number) => void;
  clicked: (slotId: string, position?: number) => void;
};

export type AdFoxConfig = {
  enabled: boolean;
  /** https://yandex.ru/support2/adfox/ru/codes/code-loader#lazyload  */
  lazyLoad?: AdFox.EmbedCode['lazyLoad'];
  autorefresh?: {
    intervalMs: number;
    triggers: Array<AdRefreshTrigger>;
    logging?: boolean;
  };
  statSendingIntervalMs?: number;
};

export type TLogTmrEvent = (props: {
  logEvent: string;
  params?: Record<string, unknown>;
}) => void;

export type TEmitYmEvent = (props: {
  eventName: string;
  params?: Record<string, string | number> | Record<string, unknown>;
}) => void;
